module.exports = __webpack_public_path__ + "img/SR3_Screen_3.27a24635.jpg";